@file:OptIn(InternalResourceApi::class)

package linx.linxapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/linx.linxapp.generated.resources/"

@delegate:ResourceContentHash(0)
internal val Res.string.empty_string: StringResource by lazy {
      StringResource("string:empty_string", "empty_string", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 20),
      ))
    }

@delegate:ResourceContentHash(520_765_495)
internal val Res.string.error_loading_cards: StringResource by lazy {
      StringResource("string:error_loading_cards", "error_loading_cards", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31, 79),
      ))
    }

@delegate:ResourceContentHash(2_066_487_415)
internal val Res.string.error_retrieving_ereceipt: StringResource by lazy {
      StringResource("string:error_retrieving_ereceipt", "error_retrieving_ereceipt", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 111, 69),
      ))
    }

@delegate:ResourceContentHash(-1_691_161_746)
internal val Res.string.merchants_near_me: StringResource by lazy {
      StringResource("string:merchants_near_me", "merchants_near_me", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 181, 49),
      ))
    }

@delegate:ResourceContentHash(388_960_382)
internal val Res.string.near_me_location_unavailable_message: StringResource by lazy {
      StringResource("string:near_me_location_unavailable_message", "near_me_location_unavailable_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 231, 124),
      ))
    }

@delegate:ResourceContentHash(-2_076_907_441)
internal val Res.string.near_me_location_unavailable_title: StringResource by lazy {
      StringResource("string:near_me_location_unavailable_title", "near_me_location_unavailable_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 356, 82),
      ))
    }

@delegate:ResourceContentHash(1_380_888_489)
internal val Res.string.near_me_no_stores_message: StringResource by lazy {
      StringResource("string:near_me_no_stores_message", "near_me_no_stores_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 439, 113),
      ))
    }

@delegate:ResourceContentHash(-292_154_295)
internal val Res.string.near_me_no_stores_title: StringResource by lazy {
      StringResource("string:near_me_no_stores_title", "near_me_no_stores_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 553, 55),
      ))
    }

@delegate:ResourceContentHash(1_917_116_522)
internal val Res.string.near_me_not_supported_message: StringResource by lazy {
      StringResource("string:near_me_not_supported_message", "near_me_not_supported_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 609, 105),
      ))
    }

@delegate:ResourceContentHash(-1_430_284_383)
internal val Res.string.near_me_not_supported_title: StringResource by lazy {
      StringResource("string:near_me_not_supported_title", "near_me_not_supported_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 715, 71),
      ))
    }

@delegate:ResourceContentHash(1_886_444_647)
internal val Res.string.near_me_open_settings: StringResource by lazy {
      StringResource("string:near_me_open_settings", "near_me_open_settings", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 787, 49),
      ))
    }

@delegate:ResourceContentHash(507_808_601)
internal val Res.string.near_me_permission_always_denied_message: StringResource by lazy {
      StringResource("string:near_me_permission_always_denied_message", "near_me_permission_always_denied_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 837, 144),
      ))
    }

@delegate:ResourceContentHash(2_114_419_463)
internal val Res.string.near_me_permission_always_denied_title: StringResource by lazy {
      StringResource("string:near_me_permission_always_denied_title", "near_me_permission_always_denied_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 982, 86),
      ))
    }

@delegate:ResourceContentHash(473_450_188)
internal val Res.string.near_me_permission_denied_browser_message: StringResource by lazy {
      StringResource("string:near_me_permission_denied_browser_message", "near_me_permission_denied_browser_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1069, 157),
      ))
    }

@delegate:ResourceContentHash(-1_732_329_181)
internal val Res.string.near_me_permission_denied_message: StringResource by lazy {
      StringResource("string:near_me_permission_denied_message", "near_me_permission_denied_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1227, 113),
      ))
    }

@delegate:ResourceContentHash(539_096_956)
internal val Res.string.near_me_permission_denied_title: StringResource by lazy {
      StringResource("string:near_me_permission_denied_title", "near_me_permission_denied_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1341, 75),
      ))
    }

@delegate:ResourceContentHash(-1_050_110_239)
internal val Res.string.near_me_stores_unavailable_message: StringResource by lazy {
      StringResource("string:near_me_stores_unavailable_message", "near_me_stores_unavailable_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1417, 94),
      ))
    }

@delegate:ResourceContentHash(-1_768_351_454)
internal val Res.string.near_me_stores_unavailable_title: StringResource by lazy {
      StringResource("string:near_me_stores_unavailable_title", "near_me_stores_unavailable_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1512, 80),
      ))
    }

@delegate:ResourceContentHash(-1_910_449_398)
internal val Res.string.near_me_try_again: StringResource by lazy {
      StringResource("string:near_me_try_again", "near_me_try_again", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1593, 37),
      ))
    }

@delegate:ResourceContentHash(1_397_295_230)
internal val Res.string.referMessage1: StringResource by lazy {
      StringResource("string:referMessage1", "referMessage1", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1631, 77),
      ))
    }

@delegate:ResourceContentHash(1_063_651_463)
internal val Res.string.referMessage2: StringResource by lazy {
      StringResource("string:referMessage2", "referMessage2", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1709, 69),
      ))
    }

@delegate:ResourceContentHash(-760_101_836)
internal val Res.string.thank_you_we_will_message: StringResource by lazy {
      StringResource("string:thank_you_we_will_message", "thank_you_we_will_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1779, 121),
      ))
    }

@delegate:ResourceContentHash(20_953_015)
internal val Res.string.valued_customer: StringResource by lazy {
      StringResource("string:valued_customer", "valued_customer", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1901, 43),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("empty_string", Res.string.empty_string)
  map.put("error_loading_cards", Res.string.error_loading_cards)
  map.put("error_retrieving_ereceipt", Res.string.error_retrieving_ereceipt)
  map.put("merchants_near_me", Res.string.merchants_near_me)
  map.put("near_me_location_unavailable_message", Res.string.near_me_location_unavailable_message)
  map.put("near_me_location_unavailable_title", Res.string.near_me_location_unavailable_title)
  map.put("near_me_no_stores_message", Res.string.near_me_no_stores_message)
  map.put("near_me_no_stores_title", Res.string.near_me_no_stores_title)
  map.put("near_me_not_supported_message", Res.string.near_me_not_supported_message)
  map.put("near_me_not_supported_title", Res.string.near_me_not_supported_title)
  map.put("near_me_open_settings", Res.string.near_me_open_settings)
  map.put("near_me_permission_always_denied_message", Res.string.near_me_permission_always_denied_message)
  map.put("near_me_permission_always_denied_title", Res.string.near_me_permission_always_denied_title)
  map.put("near_me_permission_denied_browser_message", Res.string.near_me_permission_denied_browser_message)
  map.put("near_me_permission_denied_message", Res.string.near_me_permission_denied_message)
  map.put("near_me_permission_denied_title", Res.string.near_me_permission_denied_title)
  map.put("near_me_stores_unavailable_message", Res.string.near_me_stores_unavailable_message)
  map.put("near_me_stores_unavailable_title", Res.string.near_me_stores_unavailable_title)
  map.put("near_me_try_again", Res.string.near_me_try_again)
  map.put("referMessage1", Res.string.referMessage1)
  map.put("referMessage2", Res.string.referMessage2)
  map.put("thank_you_we_will_message", Res.string.thank_you_we_will_message)
  map.put("valued_customer", Res.string.valued_customer)
}
